export default __webpack_public_path__ + "static/media/neutral.c4720c10.svg";